export default __webpack_public_path__ + "static/media/active_users_ico.8aba3023.svg";